"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceRangeInput = exports.RangeInputHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const PriceRange_common_1 = require("./PriceRange.common");
const SingleRangeInput_1 = require("./SingleRangeInput");
exports.RangeInputHeader = styled_components_1.default.div(({ theme }) => theme.doubleRange.rangeInputHeader);
const PriceRangeInput = props => {
    const { label, value, min, disabled, loading, onChange, testId = 'priceRangeInput', getTooltip, customConfig, } = props;
    const currentPriceOptions = (customConfig === null || customConfig === void 0 ? void 0 : customConfig.customPriceOptions) || PriceRange_common_1.priceOptions;
    const tooltipTemplate = (amount) => {
        var _a;
        return (((_a = currentPriceOptions.find(option => option.value === amount)) === null || _a === void 0 ? void 0 : _a.caption) || '');
    };
    const options = currentPriceOptions.filter(option => option.value === null || option.value > min);
    // NOTE: If the min value is bigger than all available price options, then we need to disable slider.
    const noOptions = options.length <= 1;
    function onChangeHandler(next) {
        onChange(next === 0 ? null : next);
    }
    return (react_1.default.createElement(exports.RangeInputHeader, null,
        label && (react_1.default.createElement("p", { className: "price-range-input-label", "data-id": "label" }, label)),
        react_1.default.createElement(SingleRangeInput_1.SingleRangeInput, { options: options, value: value, onChange: onChangeHandler, tooltipTemplate: tooltipTemplate, testId: testId, loading: loading, disabled: disabled || noOptions, getSingleRangeInputTooltip: getTooltip, customConfig: customConfig })));
};
exports.PriceRangeInput = PriceRangeInput;
//# sourceMappingURL=PriceRangeInput.js.map